import React, { useState, useEffect } from 'react'
import { SectionDivider } from '../../Home/SignedIn/common/styles'
import { SeriesBox, SeeMoreButton, BoxInfo } from './MyPracticeStyles'
import { Box, Flex, P } from '../../../ui/acro'
import MyPracticeNotData from '../MyPracticeNotData'
import AloMovesAnimation from 'components_v2/Search/common/AloMovesAnimation'
import { LoadMore } from './Components/loadMoreItems'
import { SeriesCard } from 'components_v1/SchemaSectionRenderer/common/components'

const Bundles = ({
  userBundles,
  isLoading,
  perPage,
  page,
  setPerPage,
  setPage,
  fetchBundles,
  totalBundles
}) => {
  const initialBundles = userBundles
  const [isCompleted, setIsCompleted] = useState(true)

  const loadMore = () => {
    LoadMore(setPage, setPerPage, fetchBundles, 'bundle', page, perPage)
  }

  const isValidPrimaryCategory = (category) => {
    return typeof category?.title === 'string' && category?.title.trim() !== ''
  }

  useEffect(() => {
    if (userBundles && userBundles.length > 0) {
      if (userBundles.length === totalBundles) {
        setIsCompleted(true)
      } else {
        setIsCompleted(false)
      }
    }
  }, [userBundles])

  return (
    <Flex
      alignItems='center'
      flexDirection='column'
      justifyContent='center'
      mt={['none', 'none', '1rem', '1rem']}
    >
      <Flex
        flexDirection='row'
        justifyContent={['center', 'center', 'flex-end', 'flex-end']}
        pt={['16px', 0]}
        pl={['5%', '0']}
        width='100%'
      ></Flex>
      {isLoading && <AloMovesAnimation />}
      {!isLoading && userBundles.length <= 0 && (
        <MyPracticeNotData option={'bundles'} />
      )}
      {!isLoading && userBundles.length > 0 && (
        <SeriesBox
          id='Users-Bundles'
          inTrigger={userBundles && true}
          appear={true}
        >
          {initialBundles.map((bundle) => {
            return (
              <Box
                key={bundle.id}
                width={
                  userBundles.length === 1
                    ? ['100%', '100%', 'auto', 'auto']
                    : ['100%', '33.33%', '33.33%', '33.33%']
                }
                p={['1rem 0', '1rem', '2rem', '2rem']}
                borderBottom={['1px solid #ECECEC', '0']}
                style={{
                  position: 'relative'
                }}
              >
                <Flex
                  flexDirection='row'
                  justifyContent='space-between'
                  style={{ position: 'relative', top: '30px' }}
                >
                  {bundle &&
                    isValidPrimaryCategory(bundle.product?.primaryCategory) && (
                      <P
                        padding={[
                          '0.1rem 1.3rem',
                          '0.2rem 1.3rem',
                          '0.2rem 1.3rem 0.2rem 0.8rem',
                          '0.2rem 1.3rem'
                        ]}
                        fontSize={['14px', '14px', '16px', '16px']}
                        style={{
                          textAlign: 'left',
                          background: '#fff',
                          zIndex: '1',
                          textTransform: 'uppercase',
                          fontFamily: 'Arquitecta',
                          letterSpacing: '2px',
                          fontWeight: '500',
                          display: ['none', 'none', 'none', 'block']
                        }}
                      >
                        {bundle && bundle.product?.primaryCategory?.title}
                      </P>
                    )}

                  <BoxInfo>Bundle</BoxInfo>
                </Flex>
                <SeriesCard
                  {...bundle.product}
                  alignBox={'center'}
                  variantTitle='primary'
                  variantSubtitle='primary'
                  url={`/bundles/${bundle.product.slug}`}
                  id={`my_practice_${bundle.product.slug}`}
                  pb='20px'
                />
              </Box>
            )
          })}

          <SectionDivider />
        </SeriesBox>
      )}
      {!isLoading && !isCompleted && (
        <SeeMoreButton onClick={loadMore}>See More</SeeMoreButton>
      )}
    </Flex>
  )
}

export default Bundles
